/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ProblemDetails } from '../model/problemDetails';
import { ServiceProviderUploadedDocumentsMapDto } from '../model/serviceProviderUploadedDocumentsMapDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ServiceProviderUploadedDocumentsMapService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param serviceProviderId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceProviderUploadedDocumentsMapDeleteDocumentByServiceProviderIdDelete(serviceProviderId?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiServiceProviderUploadedDocumentsMapDeleteDocumentByServiceProviderIdDelete(serviceProviderId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiServiceProviderUploadedDocumentsMapDeleteDocumentByServiceProviderIdDelete(serviceProviderId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiServiceProviderUploadedDocumentsMapDeleteDocumentByServiceProviderIdDelete(serviceProviderId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/api/ServiceProviderUploadedDocumentsMap/DeleteDocumentByServiceProviderId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceProviderId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceProviderUploadedDocumentsMapGetByServiceProviderIdGet(serviceProviderId?: string, observe?: 'body', reportProgress?: boolean): Observable<ServiceProviderUploadedDocumentsMapDto>;
    public apiServiceProviderUploadedDocumentsMapGetByServiceProviderIdGet(serviceProviderId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceProviderUploadedDocumentsMapDto>>;
    public apiServiceProviderUploadedDocumentsMapGetByServiceProviderIdGet(serviceProviderId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceProviderUploadedDocumentsMapDto>>;
    public apiServiceProviderUploadedDocumentsMapGetByServiceProviderIdGet(serviceProviderId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ServiceProviderUploadedDocumentsMapDto>('get',`${this.basePath}/api/ServiceProviderUploadedDocumentsMap/GetByServiceProviderId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceProviderUploadedDocumentsMapUpdatePut(body?: ServiceProviderUploadedDocumentsMapDto, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiServiceProviderUploadedDocumentsMapUpdatePut(body?: ServiceProviderUploadedDocumentsMapDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiServiceProviderUploadedDocumentsMapUpdatePut(body?: ServiceProviderUploadedDocumentsMapDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiServiceProviderUploadedDocumentsMapUpdatePut(body?: ServiceProviderUploadedDocumentsMapDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/api/ServiceProviderUploadedDocumentsMap/Update`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceProviderUploadedDocumentsMapUploadPost(body?: ServiceProviderUploadedDocumentsMapDto, observe?: 'body', reportProgress?: boolean): Observable<ServiceProviderUploadedDocumentsMapDto>;
    public apiServiceProviderUploadedDocumentsMapUploadPost(body?: ServiceProviderUploadedDocumentsMapDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceProviderUploadedDocumentsMapDto>>;
    public apiServiceProviderUploadedDocumentsMapUploadPost(body?: ServiceProviderUploadedDocumentsMapDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceProviderUploadedDocumentsMapDto>>;
    public apiServiceProviderUploadedDocumentsMapUploadPost(body?: ServiceProviderUploadedDocumentsMapDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ServiceProviderUploadedDocumentsMapDto>('post',`${this.basePath}/api/ServiceProviderUploadedDocumentsMap/Upload`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
